import React from 'react';

// check to see if we're in an iframe
const isEmbedded = window.top !== window.self;
const isShop = document.baseURI.includes('/shop');

const EmbedContext = React.createContext({ isEmbedded, isShop });

export default EmbedContext;
